module.exports = __webpack_public_path__ + "static/img/cooperation15.656d2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImgs/cooperation15.png
// module id = q9qh
// module chunks = 11